import homeBuyerGuideImg from '@/assets/images/lm-buyer-guide.webp';
import homeSellerGuideImg from '@/assets/images/lm-seller-guide.webp';
import relocationGuideImg from '@/assets/images/lm-relocation-guide.webp';

export default [
    {
        title: "Buyer Guide",
        category: 'Lead Magnet',
        thumbnail: homeBuyerGuideImg,
        url: 'https://www.canva.com/design/DAGCggAvVh0/ndfbGmIst4t2s_827sPVRQ/view?utm_content=DAGCggAvVh0&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
    },
    {
        title: "Seller Guide",
        category: 'Lead Magnet',
        thumbnail: homeSellerGuideImg,
        url: 'https://www.canva.com/design/DAGCgiQu_Bg/0cVCEvP7obwDvt3xxxuGrg/view?utm_content=DAGCgiQu_Bg&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
    },
    {
        title: "Relocation Guide",
        category: 'Lead Magnet',
        thumbnail: relocationGuideImg,
        url: 'https://www.canva.com/design/DAFfpTGnePA/BAqe1Hs5sk0hS0RW5kFb2Q/view?utm_content=DAFfpTGnePA&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview',
    },
];